module.exports = __webpack_public_path__ + "media/components/country-flag/static/mo-a23c7bdb264e57149ebc78d796cabb92.svg";